import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-dropdown-without-label',
  templateUrl: './dropdown-without-label.component.html',
  styleUrls: ['./dropdown-without-label.component.scss']
})
export class DropdownWithoutLabelComponent implements OnInit {
  language = 'Hindi';
  dropdownForm!: FormGroup;
  inputNgModelNojs: string = '';

  dropdownOptions = [
    { label: 'Hindi', value: 'Hindi' },
    { label: 'English', value: 'English' },
    { label: 'Tamil', value: 'Tamil' }
  ];

  constructor(
    private formBuilder: FormBuilder,
    private _activatedRoute: ActivatedRoute
  ) {
    this._activatedRoute.queryParams.subscribe(param => {
      if (param['language']) {
        this.inputNgModelNojs = param['language'];
      }
    });
  }

  ngOnInit() {
    this.dropdownForm = this.formBuilder.group({
      language: ['']
    });
  }
}